import { Box, styled, Tooltip, tooltipClasses } from '@mui/material';

export const StyledSectionPill = styled(Box)<{
  $isScheduled?: boolean;
  $zoom?: number;
}>(({ theme, $isScheduled, $zoom }) => {
  const baseSize = 10;
  const baseTop = 2;
  const baseRight = 2;

  // Scale the chip size inversely to zoom so it appears consistent
  const scaleFactor = $zoom && $zoom > 0 ? 1 / $zoom : 1;
  const scaledSize = Math.round(baseSize * scaleFactor * 100) / 100;
  const scaledTop = baseTop * scaleFactor;
  const scaledRight = baseRight * scaleFactor;

  return {
    width: scaledSize,
    height: scaledSize,
    borderRadius: '50%',
    backgroundColor: $isScheduled
      ? theme.palette.primary.dark
      : theme.palette.grey[800],
    border: `10px solid ${
      $isScheduled ? theme.palette.primary.light : theme.palette.grey[300]
    }`,
    flexShrink: 0,
    position: 'absolute',
    top: scaledTop,
    right: scaledRight,
    zIndex: 1500,
  };
});

export const StyledTooltip = styled(Tooltip)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    fontSize: '0.75rem',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.grey[800],
  },
}));
